<div class="top-banner">
  <span>Session details</span>
  <button matIconButton type="button" (click)="closeNotification($event)" aria-label="Close notification window">
    <mat-icon class="material-symbols-outlined icon-sm" fontIcon="close"/>
  </button>
</div>

<div class="meta">
  <div class="meta-item"><span>Model:</span> <span>{{model}}</span></div>
  <div class="meta-item"><span>Temperature:</span> <span>{{temperature}}</span></div>
  <div class="meta-item"><span>topP:</span> <span>{{topP}}</span></div>
</div>

<mat-nav-list role="list">
  <div mat-subheader class="sub-hdr">Agents</div>
  @if (agents.length > 0) {
    @for (agent of agents; track agent) {
      <mat-list-item role="listitem" class="list-wrapper">
        <div class="item-content">
          <div>
            <mat-icon matListItemIcon class="material-symbols-outlined" fontIcon="spoke" aria-hidden="true"/>
          </div>
          <span>{{ agent.name }}</span>
        </div>
      </mat-list-item>
    }
  } @else {
    <mat-list-item role="listitem" class="list-wrapper">
      <div class="item-content"><span>No agents attached</span></div>
    </mat-list-item>
  }
</mat-nav-list>

<mat-nav-list role="list">
  <div mat-subheader class="sub-hdr">Documents</div>
  @if (documents.length > 0) {
    @for (doc of documents; track doc) {
      <mat-list-item role="listitem" class="list-wrapper">
        <div class="item-content">
          <attachment-doc [document]="doc"></attachment-doc>
        </div>
      </mat-list-item>
    }
  } @else {
    <mat-list-item role="listitem" class="list-wrapper">
      <div class="item-content"><span>No documents attached</span></div>
    </mat-list-item>
  }
</mat-nav-list>
